import React, { useState, useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';

import { getBrowserCheckCookie, saveBrowserCheckCookie } from '@app/helpers/cookies';

import ErrorSplashScreen from './ErrorBoundary/error-splash-screen';
import ErrorBoundary from './ErrorBoundary/ErrorBoundary';
import router from './Routes/routes';

const IEWarning = () => (
  <div
    data-test="ie-warning"
    style={{
      display: 'flex',
      justifyContent: 'center',
      padding: '1rem',
      backgroundColor: '#e6f3ff',
      border: '1px solid #b3d9ff',
      borderRadius: '4px',
      margin: '1rem',
      color: '#0066cc',
    }}
  >
    <p>
      Hey there, it looks like you&apos;re using an unsupported browser, please visit
      {' '}
      <a href="https://chat.marley.ai" style={{ color: '#0066cc', textDecoration: 'underline' }}>
        chat.marley.ai
      </a>
      {' '}
      using your Chrome browser.
    </p>
  </div>
);

const Root = () => {
  const [isChrome, setIsChrome] = useState(getBrowserCheckCookie() || (!!(
    window as unknown as { chrome: boolean }
  ).chrome));

  useEffect(() => {
    saveBrowserCheckCookie(true);
    if (isChrome) setIsChrome(true);
  }, [isChrome]);

  const ua = window.navigator.userAgent;
  const isIE = ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1;

  return (
    <div className="root">
      <ErrorBoundary errorMessage={<ErrorSplashScreen />}>
        {isIE ? <IEWarning /> : <RouterProvider router={router} />}
      </ErrorBoundary>
    </div>
  );
};

export default Root;
